"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPicker = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const simple_line_icons_1 = require("./simple-line-icons");
const iconsminds_icons_1 = require("./iconsminds-icons");
const types_1 = require("./types");
//@ts-ignore                
let rwsTemplate = T.html `<div class="icon-picker${x => x.side === 'top' ? ' icon-picker-top' : ''}" ?disabled="${x => x.disabled}">
    <div class="icon-picker-trigger">
        <div class="selected-icon">
            <i class="${x => x.getPreviewClass()}"></i>
            <span class="selected-text">${x => x.getDisplayText()}</span>
        </div>
        <div class="actions">
            <button type="button" class="clear-btn" @click="${(x, c) => { c.event.stopPropagation(); x.clearSelection(); }}" title="${'iconPicker.clear'.t()}" ?hidden="${x => !x.selectedIcon}">
                <i class="simple-icon-close"></i>
            </button>
            <i class="dropdown-arrow simple-icon-arrow-${x => x.isOpen ? 'up' : 'down'}"></i>
        </div>
    </div>

    <div class="icon-picker-dropdown ${x => x.isOpen ? 'open' : ''}" ?open="${x => x.isOpen}" :style="${x => x.isOpen ? 'display: block; opacity: 1; transform: translateY(0);' : 'display: none; opacity: 0; transform: translateY(-10px);'}" @click="${(x, c) => c.event.stopPropagation()}">
        <div class="dropdown-header">
            <div class="icon-set-tabs">
                <button 
                    type="button" 
                    class="icon-set-tab ${x => x.selectedIconSet === 'simple-line-icons' ? 'active' : ''}"
                    @click="${(x, c) => { c.event.stopPropagation(); x.changeIconSet('simple-line-icons'); }}"
                >
                    Simple Line Icons
                </button>
                <button 
                    type="button" 
                    class="icon-set-tab ${x => x.selectedIconSet === 'iconsminds' ? 'active' : ''}"
                    @click="${(x, c) => { c.event.stopPropagation(); x.changeIconSet('iconsminds'); }}"
                >
                    IconsMinds
                </button>
            </div>
            <div class="search-container">
                <input 
                    type="text" 
                    class="search-input" 
                    placeholder="${'iconPicker.searchPlaceholder'.t()}"
                    :value="${x => x.searchQuery}"
                    @input="${(x, c) => x.handleSearchInput(c.event)}"
                    @click="${(x, c) => c.event.stopPropagation()}"
                />
                <i class="search-icon simple-icon-magnifier"></i>
            </div>
        </div>

        <div class="icons-grid" id="icons-grid">
            
        </div>

        <div class="results-limit-notice" ?hidden="${x => x.filteredIcons.length !== 100}">
            <i class="simple-icon-info"></i>
            <span>${'iconPicker.resultsLimited'.t()}</span>
        </div>

        <div class="no-results" ?hidden="${x => x.filteredIcons.length > 0}">
            <i class="simple-icon-info"></i>
            <span>${'iconPicker.noResults'.t()}</span>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  position: relative;
  width: 100%;
  max-width: 300px;
}

.icon-picker {
  position: relative;
}
.icon-picker[disabled] {
  opacity: 0.6;
  pointer-events: none;
}
.icon-picker.icon-picker-top .icon-picker-dropdown {
  top: auto;
  bottom: 100%;
  transform: translateY(10px);
  width: 350px;
}
.icon-picker.icon-picker-top .icon-picker-dropdown[open] {
  transform: translateY(-30px);
}
.icon-picker.icon-picker-top .icon-picker-dropdown.open {
  transform: translateY(-30px) !important;
}

.icon-picker-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 40px;
}
.icon-picker-trigger:hover {
  border-color: var(--primary-color);
}
.icon-picker-trigger:focus-within {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(115, 35, 107, 0.1);
}

.selected-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
.selected-icon i {
  color: var(--primary-color);
  font-size: 16px;
  flex-shrink: 0;
}
.selected-icon .selected-text {
  color: var(--text_color);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.actions .clear-btn {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  border-radius: 2px;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.actions .clear-btn:hover {
  background: #f5f5f5;
  color: var(--error_color);
}
.actions .clear-btn i {
  font-size: 12px;
}
.actions .dropdown-arrow {
  color: #999;
  font-size: 12px;
  transition: transform 0.2s ease;
}

.icon-picker-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 400px;
  display: none;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.2s ease;
}
.icon-picker-dropdown[open] {
  display: block;
  opacity: 1;
  transform: translateY(0);
}
.icon-picker-dropdown.open {
  display: block !important;
  opacity: 1 !important;
  transform: translateY(0) !important;
}

.dropdown-header {
  padding: 16px;
  border-bottom: 1px solid #eee;
  background: #f9f9f9;
}

.icon-set-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
}
.icon-set-tabs .icon-set-tab {
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: var(--text_color);
  transition: all 0.2s ease;
}
.icon-set-tabs .icon-set-tab:hover {
  border-color: var(--primary-color);
}
.icon-set-tabs .icon-set-tab.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}

.search-container {
  position: relative;
}
.search-container .search-input {
  width: 100%;
  padding: 8px 32px 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}
.search-container .search-input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(115, 35, 107, 0.1);
}
.search-container .search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 14px;
  pointer-events: none;
}

.icons-grid {
  max-height: 250px;
  overflow-y: auto;
  padding: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 8px;
}

.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}
.icon-item:hover {
  background: #f5f5f5;
  border-color: var(--primary-color);
}
.icon-item.selected {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}
.icon-item.selected i {
  color: #fff !important;
}
.icon-item.selected .icon-name {
  color: #fff;
}
.icon-item i {
  font-size: 18px;
  color: var(--primary-color);
}
.icon-item .icon-name {
  font-size: 10px;
  color: var(--text_color);
  word-break: break-word;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.no-results {
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px;
  color: #999;
  text-align: center;
}
.no-results i {
  font-size: 24px;
}
.no-results span {
  font-size: 14px;
}

.results-limit-notice {
  padding: 12px 16px;
  background: #f9f9f9;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 12px;
}
.results-limit-notice i {
  color: var(--primary-color);
}

.icons-grid::-webkit-scrollbar {
  width: 6px;
}

.icons-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.icons-grid::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.icons-grid::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}`;
const shadowOptions = { "mode": "open" };
let IconPicker = class IconPicker extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.placeholder = '';
        this.value = '';
        this.disabled = false;
        this.side = 'bottom';
        this.isOpen = false;
        this.searchQuery = '';
        this.selectedIconSet = 'simple-line-icons';
        this.selectedIcon = null;
        this.filteredIcons = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateFilteredIcons();
        this.parseValue();
        // Set up manual event binding for the trigger
        setTimeout(() => {
            this.renderIcons();
            this.setupEventBindings();
        }, 0);
    }
    setupEventBindings() {
        var _a;
        const trigger = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.icon-picker-trigger');
        if (trigger) {
            // Remove any existing listeners first
            trigger.removeEventListener('click', this.toggleDropdown);
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('Manual trigger click event fired');
                this.toggleDropdown();
            });
        }
    }
    setupOutsideClickListener() {
        // Set up outside click listener with a delay
        setTimeout(() => {
            document.addEventListener('click', this.handleOutsideClick.bind(this));
        }, 100);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('click', this.handleOutsideClick.bind(this));
    }
    parseValue() {
        if (!this.value) {
            this.selectedIcon = null;
            return;
        }
        // Parse format like "simple-icon-user" or "iconsminds-home"
        if (this.value.startsWith('simple-icon-')) {
            const iconName = this.value.replace('simple-icon-', '');
            if (simple_line_icons_1.simpleLineIcons.includes(iconName)) {
                this.selectedIcon = {
                    iconSet: 'simple-line-icons',
                    iconName,
                    fullClassName: this.value
                };
                this.selectedIconSet = 'simple-line-icons';
            }
        }
        else if (this.value.startsWith('iconsminds-')) {
            const iconName = this.value.replace('iconsminds-', '');
            if (iconsminds_icons_1.iconsmindsIcons.includes(iconName)) {
                this.selectedIcon = {
                    iconSet: 'iconsminds',
                    iconName,
                    fullClassName: this.value
                };
                this.selectedIconSet = 'iconsminds';
            }
        }
    }
    valueChanged() {
        this.parseValue();
        this.$emit('icon-changed', { value: this.value, selectedIcon: this.selectedIcon });
    }
    selectedIconSetChanged() {
        this.updateFilteredIcons();
        this.renderIcons();
    }
    searchQueryChanged() {
        this.updateFilteredIcons();
        this.renderIcons();
    }
    filteredIconsChanged() {
        this.renderIcons();
    }
    updateFilteredIcons() {
        const icons = this.selectedIconSet === 'simple-line-icons' ? simple_line_icons_1.simpleLineIcons : iconsminds_icons_1.iconsmindsIcons;
        if (!this.searchQuery.trim()) {
            this.filteredIcons = icons.slice(0, 100); // Limit initial display for performance
        }
        else {
            const query = this.searchQuery.toLowerCase();
            this.filteredIcons = icons.filter(icon => icon.toLowerCase().includes(query)).slice(0, 100); // Limit search results for performance
        }
    }
    renderIcons() {
        var _a;
        const iconsGrid = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#icons-grid');
        if (!iconsGrid)
            return;
        iconsGrid.innerHTML = '';
        this.filteredIcons.forEach(iconName => {
            var _a, _b;
            const prefix = this.selectedIconSet === 'simple-line-icons' ? 'simple-icon-' : 'iconsminds-';
            const fullClassName = prefix + iconName;
            const isSelected = ((_a = this.selectedIcon) === null || _a === void 0 ? void 0 : _a.iconName) === iconName && ((_b = this.selectedIcon) === null || _b === void 0 ? void 0 : _b.iconSet) === this.selectedIconSet;
            const iconItem = document.createElement('div');
            iconItem.className = `icon-item ${isSelected ? 'selected' : ''}`;
            iconItem.title = iconName;
            iconItem.dataset.iconName = iconName;
            iconItem.innerHTML = `
                <i class="${fullClassName}"></i>
                <span class="icon-name">${iconName}</span>
            `;
            iconItem.addEventListener('click', () => {
                this.selectIcon(iconName);
            });
            iconsGrid.appendChild(iconItem);
        });
    }
    toggleDropdown() {
        console.log('toggleDropdown called, disabled:', this.disabled, 'current isOpen:', this.isOpen);
        if (this.disabled)
            return;
        this.isOpen = !this.isOpen;
        console.log('toggled isOpen to:', this.isOpen);
        if (this.isOpen) {
            this.searchQuery = '';
            this.updateFilteredIcons();
            setTimeout(() => {
                this.renderIcons();
            }, 0);
            // Set up outside click listener when opening
            this.setupOutsideClickListener();
        }
    }
    isOpenChanged(oldValue, newValue) {
        console.log('isOpenChanged called:', oldValue, '->', newValue);
    }
    selectIcon(iconName) {
        const prefix = this.selectedIconSet === 'simple-line-icons' ? 'simple-icon-' : 'iconsminds-';
        const fullClassName = prefix + iconName;
        this.selectedIcon = {
            iconSet: this.selectedIconSet,
            iconName,
            fullClassName
        };
        this.value = fullClassName;
        this.isOpen = false;
        this.searchQuery = '';
        this.renderIcons(); // Re-render to show selection
    }
    clearSelection() {
        this.selectedIcon = null;
        this.value = '';
        this.isOpen = false;
    }
    changeIconSet(iconSet) {
        this.selectedIconSet = iconSet;
    }
    handleSearchInput(event) {
        const target = event.target;
        this.searchQuery = target.value;
    }
    handleOutsideClick(event) {
        var _a;
        if (!this.isOpen)
            return;
        const target = event.target;
        console.log('Outside click detected, target:', target, 'contains:', this.contains(target));
        // Check if the click is within the shadow DOM of this component
        const isInsideComponent = ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.contains(target)) || this.contains(target);
        if (!isInsideComponent) {
            console.log('Closing dropdown due to outside click');
            this.isOpen = false;
        }
        else {
            console.log('Click is inside component, keeping dropdown open');
        }
    }
    getDisplayText() {
        if (this.selectedIcon) {
            return this.selectedIcon.iconName;
        }
        return this.placeholder || 'iconPicker.selectIcon'.t();
    }
    getPreviewClass() {
        if (this.selectedIcon) {
            return this.selectedIcon.fullClassName;
        }
        return 'simple-icon-question'; // Default preview icon
    }
};
exports.IconPicker = IconPicker;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], IconPicker.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], IconPicker.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Boolean)
], IconPicker.prototype, "disabled", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], IconPicker.prototype, "side", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], IconPicker.prototype, "isOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], IconPicker.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], IconPicker.prototype, "selectedIconSet", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof types_1.SelectedIcon !== "undefined" && types_1.SelectedIcon) === "function" ? _a : Object)
], IconPicker.prototype, "selectedIcon", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], IconPicker.prototype, "filteredIcons", void 0);
exports.IconPicker = IconPicker = __decorate([
    (0, client_1.RWSView)('icon-picker', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], IconPicker);
IconPicker.defineComponent();
